import { render, staticRenderFns } from "./DocumentRecordEdit.vue?vue&type=template&id=00b09575"
import script from "./DocumentRecordEdit.vue?vue&type=script&lang=js"
export * from "./DocumentRecordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports